import classes from "./LeftSide.module.css";
import clsx from "clsx";
const LeftSide = ({ icon, disabled, right }) => (
  <span className={clsx(classes.leftSide, {
    [classes.iconDisabled]: disabled,
  })}>
    {icon}
    {right && (
      <span
        className={clsx(classes.unit, {
          [classes.disabled]: disabled,
        })}
      >
        {right}
      </span>
    )}
  </span>
);
export default LeftSide;
